import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { AbvChbkPymtPerspective } from '@/gtn/org/abv/entities/chbkPymt/AbvChbkPymtPerspective';
import { AbvMcdPymtActualsPerspective } from '@/gtn/org/abv/entities/mcdPymtActuals/AbvMcdPymtActualsPerspective';
import { AbvReservePerspective } from '@/gtn/org/abv/entities/reserve/AbvReservePerspective';
import { AbvSapActualsPerspective } from '@/gtn/org/abv/entities/sapActuals/AbvSapActualsPerspective';
import { AbvSapReconPerspective } from '@/gtn/org/abv/entities/sapRecon/AbvSapReconPerspective';
import { Route } from 'react-router-dom';
import { AbvClosureDetail } from './entities/closure/AbvClosureDetail';
import { AbvGtnSalesPerspective } from './entities/gtnSales/AbvGtnSalesPerspective';
import { AbvLbeDetail } from './entities/lbe/AbvLbeDetail';
import { AbvManAccrAdjList } from './entities/manAccrAdj/AbvManAccrAdjList';
import { AbvOverUnderScenDetail } from './entities/overUnderScen/AbvOverUnderScenDetail';
import { AbvOverUnderScenList } from './entities/overUnderScen/AbvOverUnderScenList';
import { AbvMcdPymtActualsSplitGrpDetail } from './entities/overUnderScen/mcdPymtActualsSplit/AbvMcdPymtActualsSplitGrpDetail';
import { AbvPipeDayDetail } from './entities/overUnderScen/pbmDayGrp/AbvPipeDayDetail';
import { AbvPipeDayGrpDetail } from './entities/overUnderScen/pbmDayGrp/AbvPipeDayGrpDetail';
import { AbvPriceActionPctDetail } from './entities/overUnderScen/priceActionPctGrp/AbvPriceActionPctDetail';
import { AbvPriceActionPctGrpDetail } from './entities/overUnderScen/priceActionPctGrp/AbvPriceActionPctGrpDetail';
import { AbvPbmPymtPerspective } from './entities/pbmPymt/AbvPbmPymtPerspective';
import { AbvReconDashboard } from './entities/reconDashboard/AbvReconDashboard';

const abvGtnRoutes = [
  <Route path="gtn/reserve" element={<EntityView perspectiveComponent={AbvReservePerspective} />} />,
  <Route path="gtn/sap-recon" element={<EntityView perspectiveComponent={AbvSapReconPerspective} />} />,
  <Route path="/gtn/dashboard/reserve" element={<AbvReconDashboard />} />,
  <Route path="gtn/man-accr-adj" element={<EntityView listComponent={AbvManAccrAdjList} />} />,
  <Route
    path="gtn/over-under-scen"
    element={<EntityView listComponent={AbvOverUnderScenList} detailComponent={AbvOverUnderScenDetail} />}
  />,
  <Route path="gtn/mcd-pymt-actuals" element={<EntityView perspectiveComponent={AbvMcdPymtActualsPerspective} />} />,
  <Route path="gtn/chbk-pymt" element={<EntityView perspectiveComponent={AbvChbkPymtPerspective} />} />,
  <Route path="gtn/sap-actuals" element={<EntityView perspectiveComponent={AbvSapActualsPerspective} />} />,
  <Route path="gtn/pbm-pymt" element={<EntityView perspectiveComponent={AbvPbmPymtPerspective} />} />,
  <Route path="gtn/ce-code" element={<EntityView />} />,
  <Route path="gtn/unique-client" element={<EntityView />} />,
  <Route path="gtn/pbm-map" element={<EntityView />} />,
  <Route path="gtn/gl-acct-map" element={<EntityView />} />,
  <Route path="gtn/plan" element={<EntityView />} />,
  <Route path="gtn/lbe" element={<EntityView detailComponent={AbvLbeDetail} />} />,
  <Route path="gtn/pipe-day" element={<EntityView detailComponent={AbvPipeDayDetail} />} />,
  <Route path="gtn/pipe-day-grp" element={<EntityView detailComponent={AbvPipeDayGrpDetail} />} />,
  <Route path="gtn/closure" element={<EntityView detailComponent={AbvClosureDetail} />} />,
  <Route path="gtn/lbe-item" element={<EntityView />} />,
  <Route path="gtn/channel-summary" element={<EntityView />} />,
  <Route
    path="gtn/mcd-pymt-actuals-split"
    element={<EntityView detailComponent={AbvMcdPymtActualsSplitGrpDetail} />}
  />,
  <Route
    path="gtn/mcd-pymt-actuals-split-grp"
    element={<EntityView detailComponent={AbvMcdPymtActualsSplitGrpDetail} />}
  />,
  <Route path="gtn/gtn-sales" element={<EntityView perspectiveComponent={AbvGtnSalesPerspective} />} />,
  <Route path="gtn/price-action-pct" element={<EntityView detailComponent={AbvPriceActionPctDetail} />} />,
  <Route path="gtn/price-action-pct-grp" element={<EntityView detailComponent={AbvPriceActionPctGrpDetail} />} />,
];

export default abvGtnRoutes;
